import { render, staticRenderFns } from "./master-payment.vue?vue&type=template&id=5f54f020"
import script from "./master-payment.vue?vue&type=script&lang=js"
export * from "./master-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports